export default __webpack_public_path__ + "static/media/5.cd7a7a8a.png";